import axios from "axios";

const BASE_URL = process.env.REACT_APP_DEAL_AGENT_API_URL;
const DEAL_INSIGHTS_API_URL = process.env.REACT_APP_DEAL_INSIGHTS_API_URL;

const dealsAgentApiUrl = `${BASE_URL}/deal/1.0`;
const dealsApiUrl = `${DEAL_INSIGHTS_API_URL}/deals/3.0`;

export const dealAgentApi = {
  askQuestion: async ( // sse stream the answer from the server
    payload: { question: string; sessionId?: string; dealId?: string },
    onChunk: (event: any) => void
  ): Promise<void> => {
    const data: Record<string, unknown> = { // payload to send to the server
          'question': payload.question, 
          ...(payload.dealId && { 'deal_id': payload.dealId }),
          'session' : payload.sessionId,  
    };

    const stream = await axios({
      method: "POST",
      url: payload.dealId ? `${dealsAgentApiUrl}/answer` : `${dealsAgentApiUrl}/global/answer`, // global or deal specific answer
      data,
      responseType: "stream",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream",
      },
      adapter: "fetch",
    }).then((r) => r.data);

    const reader = (stream as any) // get the reader from the stream
      .pipeThrough(new TextDecoderStream())
      .getReader();

    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += value;
      const lines = buffer.split("\n");
      buffer = lines.pop() ?? "";

      for (const line of lines) {
        if (line.startsWith("data:")) {
          const raw = line.substring(5).trim();
          if (raw) {
            try {
              const parsed = JSON.parse(raw);
              if (parsed?.error) { // sse error type
                throw new Error(parsed.error);
              }
              onChunk(parsed);
            } catch (error) { //network failure
              throw error;
            }
          }
        }
      }
    }
  },

  getSessions: async (payload: any): Promise<any> => { // history of sessions
    const response = await axios.get(
      `${dealsApiUrl}/agent/sessions`,
      {
        params: payload,
      }
    );
  
    return response.data;
  },

  getChats: async (sessionId: string): Promise<any> => { // chats for a specific session
    const response = await axios.get(
      `${dealsApiUrl}/agent/sessions/${sessionId}/chats`,
      { params: { page: 0, limit: 50 }, }
    );
    return response.data;
  },

};
